import React, {useState, useRef, useEffect} from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ListItem from '@mui/material/ListItem';
import ListSubheader from '@mui/material/ListSubheader';
import ListItemText from '@mui/material/ListItemText';
import FormLabel from '@mui/material/FormLabel';
import Checkbox from '@mui/material/Checkbox';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import axios from 'axios';
import endpoints, { getBackendUrl } from '../../../endpoints';
import { useSelector, useDispatch } from 'react-redux'
import CloseIcon from '@mui/icons-material/CloseRounded';
import {categories as categoriesAllList, countries, amounts as amountList } from '../../../utils/References';
import Confirmation from './Confirmation';
import QueryBuilder from '../parts/QueryBuilder';
import TestRssModal from './TestRssModal';
import Loading from '../../pages/parts/Loading'
import { fullHeightModalResize } from '../../../utils/Utils';

let data = null;

export default function EditFeedModal(props) {        
    if (props.dialogData) {
        data = props.dialogData;
    }
    
    const [closeConfirm, setCloseConfirm] = useState()
    const [testRssItems, setTestRssItems] = useState()
    const [testRssUrl, setTestRssUrl] = useState()
    const [testRssError, setTestRssError] = useState(null)
    const [loading, setLoading] = useState(false)
    const [categoriesList, setCategoriesList] = useState([])
    const [categories, setCategories] = useState([])
    const [excludeCountries, setExcludeCountries] = useState([])
    const [hourly, setHourly] = useState()
    const [fixedPrice, setFixedPrice] = useState()
    const [hourlyRate, setHourlyRate] = useState([0,100])    
    const [amount, setAmount] = useState([])
    const [noPrice, setNoPrice] = useState()
    const [query, setQuery] = useState()
    
    const [errors, setErrors] = useState()
    if (props.dialogData == null && errors !== null) {
        setErrors(null)
    }
    
    const [tab, setTab] = useState(0)
    if (props.dialogData == null && tab != 0) {
        setTab(0)
    }
    const token = useSelector((state) => state.auth.token)
    
    const nameRef = useRef()
    const descriptionRef = useRef()
    const minusWordsRef = useRef()
    const statusRef = useRef()
    
    const categoriesRef = useRef()
    const excludeCountriesRef = useRef()
    const hourlyRef = useRef()
    const fixedPriceRef = useRef()
    const noPriceRef = useRef()
    
    const aiModeRef = useRef()
    
    const makeParams = () => {
        let params = []
        
        // Categories and subcategories
        if (categories.length) {
            const category2_uid = categories.filter((id) => {
                return categoriesList.find((item) => {return item.id == id})?.type == 'category'
            })
            if (category2_uid.length) {
                params.push('category2_uid=' + category2_uid.join(','))
            }
            
            const subcategory2_uid = categories.filter((id) => {
                return categoriesList.find((item) => {return item.id == id})?.type == 'subcategory'
            })
            if (subcategory2_uid.length) {
                params.push('subcategory2_uid=' + subcategory2_uid.join(','))
            }
        }
        
        // Job Type
        let jobType = []
        if (hourlyRef.current.checked) {
            jobType.push('hourly')
            let a = [
                hourlyRate[0] ? hourlyRate[0] : '',
                hourlyRate[1] < 100 ? hourlyRate[1] : '',
            ].join('-').trim()
            if (a) {
                params.push('hourly_rate=' + a)
            }
            
            if (noPriceRef.current.checked) {
                jobType.push('noprice')
            }
        }
        
        if (fixedPriceRef.current.checked) {
            jobType.push('fixed')
            if (amount.length) {
                params.push('budget=' + amount.join(','))
            }
        }
        
        if (jobType.length) {
            params.push('job_type=' + jobType.join(','))
        }
        
        // Countries
        // NOTE: Sending a full "location=" allow-list of all countries creates an extremely long query string
        // and may break the upstream GraphQL request. Use a small exclude list instead.
        if (excludeCountries?.length) {
            params.push('exclude_countries=' + excludeCountries.join(','))
        }
        // ---------------
        
        params.push('api_params=1')
        
        return params.join('&')
    }
    
    const save = async () => {
        if (props.dialogData == null) return
        
        const urlParams = {
            name: nameRef.current.value,
            query: query,
            description: descriptionRef.current.value,
            params: makeParams(),
            status: statusRef.current.value,
            minusWords: minusWordsRef.current.value,
            aiMode: aiModeRef.current.value ?? 0,
        }
        
        let res = null
        try {
            if (props.dialogData.id) {
                let uri = getBackendUrl(endpoints.feeds_ext_edit, token).replace('{id}', props.dialogData.id)
                res = await axios.put(uri, urlParams)
            } else {
                let uri = getBackendUrl(endpoints.feeds_ext_add, token)
                res = await axios.post(uri, urlParams)
            }
            
            props.onSave()
        } catch (err) {
            if (err.response.data.status == 'invalidate') {
                const e = err.response.data.details
                
                for (let i in e) {
                    let s = e[i];
                    s = s.replace('"minusWords"', '"Minus Words"');
                    e[i] = s;
                }
                
                setErrors(e)
                if (Object.keys(e)[0] == 'query') {
                    setTab(1)
                } else
                if (Object.keys(e)[0] == 'minusWords') {
                    setTab(2)
                }
            }
        }
    }
    
    const tabChange = (event, newValue) => {
        setTab(newValue);
    };
    
    const instructionSaveHandle = (item) => {
        let index = -1;
        for (let i in data.finder.instructions) {
            if (data.finder.instructions[i].id == item.id) {
                index = i;
                break;
            }
        }
        
        if (index > -1) {
            data.finder.instructions[index] = item;
        } else {
            data.finder.instructions.push(item);
        }
    }
    
    const instructionDeleteHandle = (item) => {
        let i = data.finder.instructions.indexOf(item);
        data.finder.instructions.splice(i, 1);
    }
    
    const hourlyRateHandle = (event, newValue) => {
        setHourlyRate(newValue);
    }
    
    const hourlyRateText = (value) => {
        if (value < 10) {
            return 'Under $10'
        }
        
        if (value > 90) {
            return '$100+'
        }
        
        return `$${value}`;
    }
    
    const testRssHandle = async () => {
        setLoading(true)
        try {
            let uri = getBackendUrl(endpoints.feeds_ext_rss_test, token)
            let params = {
                query: query || '',
                params: makeParams(),
                minus_words: minusWordsRef.current.value,
            }
            let res = await axios.post(uri, params)
            setTestRssError(res?.data?.error ? String(res.data.error) : null)
            setTestRssItems(Array.isArray(res?.data?.items) ? res.data.items : [])
            setTestRssUrl(res?.data?.url ?? null)
        } catch (e) {
            const message =
                e?.response?.data?.message ||
                e?.response?.data?.status ||
                e?.message ||
                'Unknown error'
            setTestRssError(String(message))
            setTestRssItems([])
            setTestRssUrl(null)
        }
        setLoading(false)
    }
    
    useEffect(() => { // Open
        setCategories([])
        setExcludeCountries([])
        setHourly(false)
        setHourlyRate([0, 100])
        setFixedPrice(false)
        setAmount([])
        setNoPrice(false)
        const categoriesTmp = [];
        data?.params?.split('&').map((item) => {
            let p = item.split('=')
            if (p[0] == 'category2_uid') {  // Categories
                p[1].split(',').map((item) => categoriesTmp.push(item))
            } else
            if (p[0] == 'subcategory2_uid') {  // Categories
                p[1].split(',').map((item) => categoriesTmp.push(item))
            } else
            if (p[0] == 'location') {  // Countries
                let ls = [];
                let a = p[1].split(',')
                countries.map((country) => {
                    if (a.indexOf(country) === -1) {
                        ls.push(country)
                    }
                })
                setExcludeCountries(ls)
            } else
            if (p[0] == 'exclude_countries') {  // Countries
                setExcludeCountries((p[1] || '').split(',').filter(Boolean))
            } else
            if (p[0] == 'job_type') {
                let a = p[1].split(',');
                setHourly(a.indexOf('hourly') > -1 ? true : false)
                setFixedPrice(a.indexOf('fixed') > -1 ? true : false)
                setNoPrice(a.indexOf('noprice') > -1 ? true : false)
            } else
            if (p[0] == 'hourly_rate') {
                let a = p[1].split('-')
                setHourlyRate([
                    a[0] ? parseInt(a[0]) : 0,
                    a[1] ? parseInt(a[1]) : 100
                ])
            } else 
            if (p[0] == 'budget') {
                setAmount(p[1].split(','))
            } else 
            if (p[0] == 'api_params') {
                //
            } else {
                console.log(p[0])
            }
        })
        setCategories(categoriesTmp)
        setQuery(data?.query)
    }, [props.dialogData])

    const resize = () => {
        fullHeightModalResize()
    }
    
    useEffect(() => {
        fullHeightModalResize()
    }, [tab])
    
    useEffect(() => {
        fullHeightModalResize()
        
        window.removeEventListener('resize', resize)
        window.addEventListener('resize', resize)
        
        const tmp = [];
        categoriesAllList.map((cat) => {
            tmp.push({
                type: 'group',
                id: null,
                title: cat.title
            })
            
            tmp.push({
                type: 'category',
                id: cat.id,
                title: 'All - ' + cat.title
            })
            
            cat.topics.map((sub) => {
                tmp.push({
                    type: 'subcategory',
                    id: sub.id,
                    title: sub.title,
                    categoryId: cat.id
                })
            })
        })
        setCategoriesList(tmp)
    }, [])

    return (
        <Dialog open={props.dialogData ? true : false} fullWidth maxWidth="md" onClose={() => {
            setCloseConfirm(true)
            return false;
        }}>
            <form onSubmit={(e) => {e.preventDefault()}}>
                <DialogTitle>
                    <Stack spacing={1.5}>
                        {props?.dialogData?.cloning ? 'Feed Cloning'
                        : 'Feed Properties' }
                        <IconButton
                            onClick={props.onClose}
                            sx={{
                              position: 'absolute',
                              right: 8,
                              top: 8,
                              color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                        <Box sx={{ width: '100%', marginBottom: 2 }}>
                            <Tabs value={tab} onChange={tabChange}>
                                <Tab value={0} label="General" />
                                <Tab value={1} label="RSS" />
                                <Tab value={2} label="Minus Words" />
                                <Tab value={3} label="AI" />
                            </Tabs>
                        </Box>
                    </Stack>
                </DialogTitle>
                <DialogContent className="dialogContentFullHeight" sx={{display: 'flex', flexDirection: 'column'}}>
                    <Stack spacing={2} sx={(tab == 0 ? {flexGrow:1} : {display: 'none'})}>
                        <Grid container spacing={3} sx={{flexGrow:1}}>
                            <Grid item md={6} xs={12}>
                                <Stack spacing={2}>
                                    <TextField
                                        fullWidth 
                                        name="name" 
                                        label="Name" 
                                        variant="filled" 
                                        helperText={errors?.name}
                                        error={errors?.name}
                                        defaultValue={data?.name}
                                        inputRef={nameRef}
                                    />
                                    <FormControl 
                                        fullWidth 
                                        variant="filled"
                                        error={errors?.status}
                                    >
                                        <InputLabel id="feedStatusLabel">Status</InputLabel>
                                        <Select
                                            name="status"
                                            fullWidth
                                            labelId="feedStatusLabel"
                                            label="Status"
                                            defaultValue={data?.status || ''}
                                            inputRef={statusRef}
                                        >
                                            <MenuItem value='active'>Active</MenuItem>
                                            <MenuItem value='inactive'>Inactive</MenuItem>
                                        </Select>
                                        <FormHelperText>{errors?.status}</FormHelperText>
                                    </FormControl>
                                </Stack>
                            </Grid>
                            <Grid item md={6} xs={12} sx={{flexGrow:1}}>
                                <TextField
                                    fullWidth
                                    className="textareaFullHeight"
                                    name="description" 
                                    label="Notes" 
                                    variant="filled"
                                    multiline
                                    rows={5}
                                    helperText={errors?.description}
                                    error={errors?.description}
                                    defaultValue={data?.description}
                                    inputRef={descriptionRef}
                                />
                            </Grid>
                        </Grid>
                    </Stack>
                    <Stack spacing={2} sx={(tab == 1 ? {flexGrow:1} : {display: 'none'})}>
                        <Grid container spacing={3} sx={{ flexGrow:1, }}>
                            <Grid item md={6} xs={12}>
                                <QueryBuilder
                                    query={data?.query} 
                                    onChange={(q) => {setQuery(q)}} 
                                    error={errors?.query}
                                />
                            </Grid>
                            <Grid item md={6} xs={12}>
                                <Stack spacing={2}>
                                    <FormControl variant="filled" fullWidth>
                                        <InputLabel id="categoriesLabel">Categories</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="categoriesLabel"
                                            label="Categories"
                                            value={categories}
                                            onChange={(e) => {
                                                const val = e.target.value
                                                let newVal = []
                                                const append = val.filter((id) => {return !categories.includes(id)})
                                                
                                                if (append.length == 0) {
                                                    newVal = val
                                                } else {
                                                    const curr = categoriesList.find((item) => {return item.id == append[0]})
                                                    if (curr.type == 'category') {
                                                        const subItems = categoriesList.filter((item) => {
                                                            return item.categoryId == curr.id
                                                        }).map((item) => {
                                                            return item.id
                                                        })
                                                        newVal = val.filter((id) => {return !subItems.includes(id)})
                                                    } else
                                                    if (curr.type == 'subcategory') {
                                                        newVal = val.filter((id) => {return id != curr.categoryId})
                                                    }
                                                }
                                                setCategories(newVal)
                                            }}
                                            multiple
                                            variant="filled"
                                            renderValue={(selected) => (
                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                    {selected?.map((value, key) => (
                                                        <Chip key={value} label={categoriesList.find((item) => {
                                                            return item.id == value
                                                        })?.title} size="small"/>
                                                    ))}
                                                </Box>
                                            )}
                                        >
                                            {categoriesList?.map((row, key) => {
                                                return (row.id ?
                                                <MenuItem key={key} value={row.id} sx={{p:0, pl:1, pr:1}}>
                                                    <Checkbox checked={categories.indexOf(row.id) > -1} />
                                                    <ListItemText primary={row.title} />
                                                </MenuItem>
                                                : <ListSubheader key={key}>{row.title}</ListSubheader>)
                                            })}
                                        </Select>
                                    </FormControl>
                                    <FormControl variant="filled" fullWidth>
                                        <InputLabel id="countiesLabel">Exclude Countries</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="countiesLabel"
                                            label="Exclude Countries"
                                            value={excludeCountries}
                                            onChange={(e) => setExcludeCountries(e.target.value)}
                                            multiple
                                            variant="filled"
                                            renderValue={(selected) => (
                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                    {selected?.map((value) => (
                                                        <Chip key={value} label={value} size="small"/>
                                                    ))}
                                                </Box>
                                            )}
                                            sx={{'& div': {maxHeight: '90px', overflow: 'auto'} }}
                                        >
                                            {countries?.map((row) => (
                                                <MenuItem key={row} value={row} sx={{p:0, pl:1, pr:1}}>
                                                    <Checkbox checked={excludeCountries?.indexOf(row) > -1} />
                                                    <ListItemText primary={row} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    
                                    <FormLabel sx={{mt:'2rem!important'}}>Contract Type</FormLabel>
                                    <Stack direction="row" sx={{ pl: '11px' }}>
                                        <FormControlLabel control={
                                            <Checkbox 
                                                inputRef={hourlyRef} 
                                                checked={hourly} 
                                                onChange={(e) => {
                                                    setHourly(e.target.checked)
                                                }} 
                                            />
                                        } label="Hourly" sx={{mt:'0rem!important', flexGrow: 1}} />
                                        { hourly ?
                                        <FormControlLabel control={
                                            <Checkbox 
                                                inputRef={noPriceRef} 
                                                checked={noPrice} 
                                                onChange={(e) => {
                                                    setNoPrice(e.target.checked)
                                                }} 
                                            />
                                        } label="No Price" sx={{mt:'0rem!important', flexGrow: 1}} />
                                        : null }
                                    </Stack>
                                    {hourly ?
                                    <Box sx={{pl:4, pr:4, pt:1.25, pb:1}}>
                                        <Slider
                                            getAriaLabel={() => 'Hourly Rate'}
                                            value={hourlyRate}
                                            onChange={hourlyRateHandle}
                                            valueLabelDisplay="on"
                                            valueLabelFormat={hourlyRateText}
                                            min={0}
                                            max={100}
                                            step={10}
                                        />
                                    </Box>
                                    : null }
                                    <FormControlLabel control={
                                        <Checkbox 
                                            inputRef={fixedPriceRef} 
                                            checked={fixedPrice} 
                                            onChange={(e) => {
                                                setFixedPrice(e.target.checked)
                                            }} 
                                        />
                                    } label="Fixed Price" sx={{ mt:'0rem!important' }} />
                                    {fixedPrice ?
                                    <FormControl variant="filled" fullWidth sx={{mt:'0.5rem!important'}}>
                                        <InputLabel id="amountLabel">Amount</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="amountLabel"
                                            label="Amount"
                                            value={amount}
                                            onChange={(e) => setAmount(e.target.value)}
                                            multiple
                                            variant="filled"
                                            renderValue={(selected) => (
                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                    {selected?.map((value, key) => (
                                                        <Chip key={value} label={amountList.find((item) => {
                                                            return item.id == value
                                                        })?.title} size="small"/>
                                                    ))}
                                                </Box>
                                            )}
                                        >
                                            {amountList?.map((row, key) => {
                                                return (row.id ?
                                                <MenuItem key={key} value={row.id} sx={{p:0, pl:1, pr:1}}>
                                                    <Checkbox checked={amount.indexOf(row.id) > -1} />
                                                    <ListItemText primary={row.title} />
                                                </MenuItem>
                                                : <ListSubheader>{row.title}</ListSubheader>)
                                            })}
                                        </Select>
                                    </FormControl>
                                    : null }
                                </Stack>
                            </Grid>
                        </Grid>
                    </Stack>
                    <Stack spacing={2} sx={(tab == 2 ? {flexGrow:1} : {display: 'none'})}>
                        <Grid container spacing={3} sx={{ flexGrow:1 }}>
                            <Grid item md={6} xs={12}>
                                <TextField
                                    fullWidth
                                    className="textareaFullHeight"
                                    name="minusWords" 
                                    label="Minus Words" 
                                    variant="filled" 
                                    multiline
                                    rows={14}
                                    helperText={errors?.minusWords}
                                    error={errors?.minusWords}
                                    defaultValue={data?.minus_words}
                                    inputRef={minusWordsRef}
                                />
                            </Grid>
                        </Grid>
                    </Stack>
                    <Stack spacing={2} sx={(tab == 3 ? {} : {display: 'none'})}>
                        <Grid container spacing={3} sx={{ flexGrow:1 }}>
                            <Grid item md={6} xs={12}>
                                <Stack spacing={2}>
                                    <FormControl 
                                        fullWidth 
                                        variant="filled"
                                        error={errors?.ai_mode}
                                    >
                                        <InputLabel id="aiModeLabel">Mode</InputLabel>
                                        <Select
                                            name="ai_mode"
                                            fullWidth
                                            labelId="aiModeLabel"
                                            label="Status"
                                            defaultValue={data?.ai_mode || '0'}
                                            inputRef={aiModeRef}
                                        >
                                            <MenuItem value="0">Disabled</MenuItem>
                                            <MenuItem value="1">Uses All Assessments</MenuItem>
                                        </Select>
                                        <FormHelperText>{errors?.ai_mode}</FormHelperText>
                                    </FormControl>
                                </Stack>
                            </Grid>
                        </Grid>
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={testRssHandle}>Test Rss</Button>
                    <Stack sx={{flexGrow:1}} />
                    <Button onClick={props.onClose}>Cancel</Button>
                    <Button type="submit" onClick={save}>{props?.dialogData?.cloning ? 'Clone' : 'Save'}</Button>
                </DialogActions>
            </form>
            <Confirmation data={closeConfirm} content="Would you like to close this window?" onResponse={(result) => {
                if (result) {
                    props.onClose()
                }
                setCloseConfirm(null)
            }}/>
            <TestRssModal 
                items={testRssItems} 
                url={testRssUrl}
                error={testRssError}
                onClose={() => {setTestRssItems(null)}} 
            />
            {loading ? <Loading /> : null }
        </Dialog>
    );
}